var isUserLoggedIn;

Date.now = Date.now || function () { return +new Date; }; //IE8 Compatibility

//Helper methods
function getAlertMessage(key, alertContainer) {
    if (store.get(key)) {
        var message = store.get(key);
        var defaults = {
            alertClass: 'alert-success'
        };
        var extendedMessage = $.extend(true, {}, defaults, message);

        var alert = $('<div class="alert ' + extendedMessage.alertClass + ' "><button type="button" class="close" data-dismiss="alert">&times;</button><h4>' + extendedMessage.title + '</h4></div>');
        if (extendedMessage.alertMessage) {
            alert.append('<p>' + extendedMessage.alertMessage + '</p>');
        }
        alert.appendTo(alertContainer || '#alertContainer');
        store.remove(key);
    }
}

function postAsJson(url, data, success, error) {
    $.ajax({
        url: url,
        type: "POST",
        dataType: "json", // expected format for response
        contentType: "application/json", // send as JSON
        data: data,
        success: success,
        error: error
    });
}

// create a form on the page and post it via a normal browser submit
function postAsForm(path, params, method) {
    method = method || "post"; // Set method to post by default if not specified.

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    var requestVerificationTokenField = document.createElement("input");
    requestVerificationTokenField.setAttribute("type", "hidden");
    requestVerificationTokenField.setAttribute("name", "__RequestVerificationToken");
    requestVerificationTokenField.setAttribute("value", Cookies.get('CSRF-TOKEN'));

    form.appendChild(requestVerificationTokenField);

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

function tagUserAccount(userAccountId, isTagged, callback) {
    postAsJson('/api/Admin/UserAccountTag/' + userAccountId, JSON.stringify({ isTagged: isTagged }), function (success) {
        if (success) {
            if (callback) {
                callback();
            }
        }
    });
}

function getFilterParams(data) {
    for (key in data) {
        var value = data[key];
        if (value == null || value == "") {
            delete data[key];
        }
        else if (Array.isArray(data[key])) {
            data[key] = data[key].join(",");
        }
    }

    var params = $.param(data);

    if (params) {
        return '?' + params;
    }

    return '?clear=true';
}

function getQueryStringParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]").toLowerCase();

    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search.toLowerCase());

    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

var loadingCount = 0;

function registerPopovers() {
    //Show popover tooltips
    $('.popoverHelp').popover({
        title: '<i class="fa fa-question"></i>&nbsp; Help'
    }).on("show.bs.popover", function () {
        var popoverClasses = $(this).data('popoverClasses');
        if (popoverClasses) {
            $(this).data("bs.popover").tip().addClass(popoverClasses);
        }
    });
}

function registerAjaxEvents() {
    $(document).ajaxError(function (event, jqxhr, settings, exception) {
        try {
        }
        catch (err) {
            //Do nothing.  We don't want this to throw another error and cause issues with the app
        }
    });

    $.ajaxSetup({
        headers: {
            RequestVerificationToken: Cookies.get('CSRF-TOKEN'),
        },
        beforeSend: function (jqXHR, settings) {
            loadingCount++;

            var completeEvents = [];

            completeEvents.push(function (jqXHR, textStatus) {
                loadingCount--;
                if (loadingCount <= 0) {
                    // hide gif here
                    hideLoadingSpinner();
                }
            });

            if (settings.complete) {
                if ($.isArray(settings.complete)) {
                    $.each(settings.complete, function (ev) {
                        completeEvents.push(ev);
                    });
                }
                else {
                    completeEvents.push(settings.complete);
                }
            }

            settings.complete = completeEvents;

            // show gif here
            showLoadingSpinner();
        },
        cache: false //prevent caching in internet explorer
    });
}

function showLoadingSpinner() {
    $("#loading").removeClass('hide');
    $("#loading").show();
}

function hideLoadingSpinner() {
    $("#loading").addClass('hide');
    $("#loading").hide();
}

var pageGuidedHelp = [];
var pageHelpHints = [];
var introJsAfterCurrentStepAction;

// This should be called from each page once all the guided help is registered in the pageGuidedHelp array
function startPageHelp() {
    var guidedHelp;

    if (pageGuidedHelp.length > 0) {
        for (var i = 0; i < pageGuidedHelp.length; i++) {
            guidedHelp = pageGuidedHelp[i];

            // Check to see if the user has already completed this guided help.
            var userStatus = userGuidedHelp[guidedHelp.guidedHelpKey];

            if (userStatus != null) {
                // If the user has started the help but not completed then start it at the latest step. Other wise skip the help if they have completed
                if (userStatus.hasUserCompleted || userStatus.hasUserDismissed) {
                    continue;
                }
                else {
                    startIntroJs(guidedHelp, guidedHelp.introJs, userStatus.currentStep);
                    break;
                }
            }
            else {
                // If the user hasn't started the help then start it and log the first step as completed
                startIntroJs(guidedHelp, guidedHelp.introJs);
                break;
            }
        }
    }

    // Add a link to each guided help to the help modal container
    for (i = 0; i < pageGuidedHelp.length; i++) {
        guidedHelp = pageGuidedHelp[i];

        var helpLink = $('<a class="btn btn-primary" href="#">' + guidedHelp.title + '</a>');

        helpLink.click(function () {
            $("#publicHelpModal").modal('hide');

            startIntroJs(guidedHelp, guidedHelp.introJs);
        });

        helpLink.appendTo("#guidedHelpContainer");
    }

    if (pageGuidedHelp.length > 0) {
        $("#guidedHelpContainer").removeClass('hidden');
    }

    if (pageHelpHints.length > 0) {
        $("#showPageHints").removeClass('hidden');
    }
}

function startIntroJs(guidedHelp, introJs, currentStep) {
    introJs.onchange(function (targetElement) {
        var currentStep = this._currentStep; // this is the introJs object in this scope

        if (typeof introJsAfterCurrentStepAction === 'function') {
            introJsAfterCurrentStepAction();
            introJsAfterCurrentStepAction = null;
        }

        if (typeof this._options.steps[currentStep].beforeAction === 'function') {
            this._options.steps[currentStep].beforeAction();
        }

        if (typeof this._options.steps[currentStep].afterAction === 'function') {
            introJsAfterCurrentStepAction = this._options.steps[currentStep].afterAction;
      }

        console.log('current step is ' + currentStep);
        postAsJson('/GuidedHelpCompletedStep/' + userGuidedHelp.guidedHelpPageKey + '/' + guidedHelp.guidedHelpKey + '/' + (currentStep + 1));
    });

    introJs.oncomplete(function () {
        if (typeof introJsAfterCurrentStepAction === 'function') {
            introJsAfterCurrentStepAction();
            introJsAfterCurrentStepAction = null;
        }

        introJs.onexit(function () { }); //don't dismiss on exit once completed
        postAsJson('/GuidedHelpCompleted/' + userGuidedHelp.guidedHelpPageKey + '/' + guidedHelp.guidedHelpKey);
    });

    introJs.onexit(function () {
        if (typeof introJsAfterCurrentStepAction === 'function') {
            introJsAfterCurrentStepAction();
            introJsAfterCurrentStepAction = null;
        }

        postAsJson('/GuidedHelpDismissed/' + userGuidedHelp.guidedHelpPageKey + '/' + guidedHelp.guidedHelpKey);
    });

    introJs.setOptions({
      exitOnOverlayClick: (typeof isMobileBrowser !== 'undefined' ? isMobileBrowser : false)
    });

    introJs.start();

  if (typeof currentStep !== 'undefined') {
        introJs.goToStep(currentStep);
    }
}

function getCommaSepString(selector) {
    var obj = $(selector);
    if (obj && obj.val()) {
        var length = obj.length;
        if (length > 0) {
            if (Array.isArray(obj.val())) {
                return obj.val().join();
            }
            if (length === 1) {
                return obj.val();
            }
            else {
                return obj.val().join();
            }
        }
    }

    return null;
}

function setDefaultListPageFilters(setDefaultBtn, filters) {
    var listPageKey = setDefaultBtn.data('listPageKey');

    var data = {
        listPageKey: listPageKey,
        defaultListPageFilters: JSON.stringify(filters, (key, value) => {
            if (value !== null) {
                return value
            }
        })
    }

    postAsJson('/api/Admin/SetDefaultListPageFilters', JSON.stringify(data), function (result) {
        if (result.success) {
            setDefaultBtn.find('i.fa').removeClass('fa-star-o').addClass('fa-star');
        }
    });
}

function stringToBool(string) {
    if (string === 'False' || string === 'false' || string === 'undefined' || string === 'null' || string === '0' || string === 'off' || string === '' || string === false || string === undefined) {
        return false;
    }

    return true;
}

$(function ($) {
    registerPopovers();

    registerAjaxEvents();

    //Prevents a double click on form submits
    $('form').submit(function () {
        //**Need to check to make sure there isn't a pending request here. If using remote validation valid will return true
        //if the api call hasn't came back yet. JE 5/11/2018
        if (!$(this).valid || ($(this).valid() && $(this).validate().pendingRequest === 0)) { //Added check.. valid() will fail on pages that do not include jquery validation js - STH 04/13/2017
            $(this).find(':submit').prop('disabled', true);

            //Used when the form is submitted through jQuery
            $('.saveButton').addClass('disabled');
        }
    });

    $('#showPageHints').click(function (e) {
        $("#publicHelpModal").modal('hide');

        if (pageHelpHints.length > 0) {
            pageHintsIntroJs = new introJs();

            pageHintsIntroJs.setOptions({
                hints: pageHelpHints
            });

            pageHintsIntroJs.addHints();
        }
    });

    //Ensure submit button, disabled on submit, is re-enabled
    $(".modal").on('shown.bs.modal', function () {
        $(this).find(':submit').not('.deleteConfirmButton').prop('disabled', false);
        $(this).find('.saveButton').not('.deleteConfirmButton').removeClass('disabled');
        $(this).find('.disabled').not('.deleteConfirmButton').not('.excludeFromReEnable').removeClass('disabled');
        $(this).find('[autofocus]').focus();
    });

    $('.saveButton').click(function () {
        $(this).addClass('disabled');
    });

    if (typeof ($.fn.dataTable) === 'function') {
        $.extend($.fn.dataTable.defaults, {
            responsive: true
        });
    }

  //High Contrast Mode
  $("#highContrastToggle").click(function () {
    var highContrastCookie = Cookies.get('HighContrast');
    if (isUserLoggedIn) {
      Cookies.set('HighContrast', 'Off');
      $.post('/api/Home/UpdateUserAccountContrastSetting', null, function (success) {
        if (success) {
          window.location.reload();
        }
      });
    }
    else {
      if (highContrastCookie == null) {
        Cookies.set('HighContrast', 'On');
        window.location.reload();
      }
      else if (highContrastCookie == 'On') {
        Cookies.set('HighContrast', 'Off');
        window.location.reload();
      }
      else if (highContrastCookie == 'Off') {
        Cookies.set('HighContrast', 'On');
        window.location.reload();
      }
    }
  });
});

$.fn.exists = function () {
    return this.length !== 0;
}
